
import React, { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../FirebaseComp/firebase';
import jsPDF from 'jspdf';
import './viewpayment.css';

function ViewPayment() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentUserEmail, setCurrentUserEmail] = useState('');

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        setCurrentUserEmail(user.email);
      } else {
        setCurrentUserEmail('');
      }
    });
    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    if (!currentUserEmail) return;

    const fetchPayments = async () => {
      try {
        const paymentsRef = collection(db, 'payments');
        const q = query(
          paymentsRef,
          where('studentEmail', '==', currentUserEmail),
          orderBy('createdAt', 'desc')
        );
        
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const paymentsData = [];
          querySnapshot.forEach((doc) => {
            paymentsData.push({
              id: doc.id,
              ...doc.data()
            });
          });
          setPayments(paymentsData);
          setLoading(false);
        });

        return () => unsubscribe();
      } catch (err) {
        setError(err.message);
        setLoading(false);
        console.error("Error fetching payments: ", err);
      }
    };

    fetchPayments();
  }, [currentUserEmail]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatPaymentType = (type) => {
    switch(type) {
      case 'bank_transfer': return 'Bank Transfer';
      case 'deposit': return 'Deposit';
      default: return type;
    }
  };

  const formatPaymentFor = (type) => {
    switch(type) {
      case 'exam': return 'Exam Fee';
      case 'admission': return 'Admission Fee';
      case 'class': return 'Class Fee';
      default: return type;
    }
  };


  const generatePaymentSlip = (payment) => {            
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });


    const logo = "/round-logo.png"; 

    // Header
    doc.setFillColor(21, 27, 84);
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
      doc.addImage(logo, "PNG", 40, 0, 25, 25);
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text("Eye Care Institute", doc.internal.pageSize.getWidth() / 2, 12, { align: "center" });
    doc.setFontSize(10);
    doc.text("College of Optometry and Vision Science", doc.internal.pageSize.getWidth() / 2, 18, { align: "center" });




    // Payment Slip Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("PAYMENT RECEIPT", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });




    // Payment Details
    doc.setFontSize(10);
    doc.text(`Receipt No: ${payment.paymentNumber}`, 15, 45);
    doc.text(`Date: ${formatDate(payment.paymentDate)}`, doc.internal.pageSize.getWidth() - 15, 45, { align: "right" });

    doc.text("Student Name:", 15, 55);
    doc.text(payment.studentName, 45, 55);

    doc.text("Student Email:", 15, 62);
    doc.text(payment.studentEmail, 45, 62);

    doc.text("Payment For:", 15, 69);
    doc.text(formatPaymentFor(payment.paymentfor), 45, 69);

    doc.text("Payment Type:", 15, 76);
    doc.text(formatPaymentType(payment.paymentType), 45, 76);




    // Amount
    doc.setFont("helvetica", "bold");
    doc.text("Amount Paid:", 15, 83);
    doc.text(`LKR ${payment.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 15, 83, { align: "right" });
    doc.line(15, 87, doc.internal.pageSize.getWidth() - 15, 87);



    // Footer
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("932, Maradana Road, Colombo 08", doc.internal.pageSize.getWidth() / 2, 120, { align: "center" });
    doc.text("Email: ecinstitute@gmail.com | Phone: 011-268-22-77", doc.internal.pageSize.getWidth() / 2, 125, { align: "center" });
    doc.text("Website: www.eyecareinstitute.lk", doc.internal.pageSize.getWidth() / 2, 130, { align: "center" });

    // Signature
    doc.setFontSize(10);
    doc.text("Thank you for your payment!", doc.internal.pageSize.getWidth() / 2, 110, { align: "center" });
    doc.line(doc.internal.pageSize.getWidth() / 2 - 30, 115, doc.internal.pageSize.getWidth() / 2 + 30, 115);

    // Save the PDF
    doc.save(`Payment_Slip_${payment.paymentNumber}.pdf`);
  };




  return (
    <>
      <section className="hero">
        <div className="hero-image">
          <img src="/round-logo.png" alt="conference" />
        </div>
        <div className="hero-content">
                <h1>Eye Care Clinic & Optical</h1>
                <p>
                Providing trusted eye clinic and quality optical services since 2007, 
                our clinic is committed to enhancing eye health and improving lives through 
                expert care and advanced solutions.
                </p>
        </div>
      </section>


      <section className="payment-history">
        <h2>Your Payment History</h2>

        {loading && <div className="loading">Loading payment history...</div>}
        {error && <div className="error">Error: {error}</div>}

        {payments.length === 0 ? (
          <div className="no-payments">No payment records found.</div>
        ) : (
          <div className="payments-table-container">
            <table className="payments-table">
              <thead>
                <tr>
                  <th>Payment #</th>
                  <th>Student Name</th> 811 px
                  <th>Student Email</th>

                  <th>Date</th>
                  <th>Payment Type</th>
                  <th>Payment For</th>
                  <th>Amount (LKR)</th>
                  <th>Download Slip</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment) => (
                  <tr key={payment.id}>
                    <td>{payment.paymentNumber}</td>
                    <td>{payment.studentName}</td>
                    <td>{payment.studentEmail}</td>
                    <td>{formatDate(payment.paymentDate)}</td>
                    <td>{formatPaymentType(payment.paymentType)}</td>
                    <td>{formatPaymentFor(payment.paymentfor)}</td>
                    <td className="amount">{payment.amount.toFixed(2)}</td>
                    <td>
                      <button 
                        className="download-btn"
                        onClick={() => generatePaymentSlip(payment)}
                      >
                        Download
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </>
  );
}

export default ViewPayment;